import { SupplierCreatePage } from '@/features/supplier/pages/SupplierCreatePage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/supplier/create')({
  component: SupplierCreatePage,
})
